import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export type IndexStatus =
  | 'Complete'
  | 'Failed'
  | 'Draft'
  | 'InProgress'
  | undefined;

export interface IRequestField {
  FieldId: number;
  AnalyzerId: number;
}

export interface ICreateCustomIndex {
  IndexName: string;
  SecurityGroupIds: number[];
  SavedSearchId: number | null;
  Fields: IRequestField[];
  NotificationEmails: string[];
}

export interface IIndexState {
  tabValue: number;
  createCustomIndex: ICreateCustomIndex;
  indexStatus: IndexStatus;
  isReadOnlyView: boolean;
}

const initialState: IIndexState = {
  tabValue: 0,
  createCustomIndex: {
    IndexName: '',
    SecurityGroupIds: [],
    SavedSearchId: null,
    Fields: [],
    NotificationEmails: [],
  },
  indexStatus: undefined,
  isReadOnlyView: false,
};

const createCustomIndexSlice = createSlice({
  name: 'indexManagement',
  initialState,
  reducers: {
    setTabValue(state, action: PayloadAction<number>) {
      state.tabValue = action.payload;
    },
    setCreateCustomIndex(
      state,
      action: PayloadAction<Partial<ICreateCustomIndex>>
    ) {
      state.createCustomIndex = {
        ...state.createCustomIndex,
        ...action.payload,
      };
    },
    setIndexName(state, action: PayloadAction<string>) {
      state.createCustomIndex.IndexName = action.payload;
    },
    setSecurityGroupIds(state, action: PayloadAction<number[]>) {
      state.createCustomIndex.SecurityGroupIds = action.payload;
    },
    setSavedSearchId(state, action: PayloadAction<number>) {
      state.createCustomIndex.SavedSearchId = action.payload;
    },
    setFields(state, action: PayloadAction<IRequestField[]>) {
      state.createCustomIndex.Fields = action.payload;
    },
    setNotificationEmails(state, action: PayloadAction<string[]>) {
      state.createCustomIndex.NotificationEmails = action.payload;
    },
    setIsReadyOnlyView(state, action: PayloadAction<boolean>) {
      state.isReadOnlyView = action.payload;
    },
    setIndexStatus(state, action: PayloadAction<IndexStatus>) {
      state.indexStatus = action.payload;
    },
    resetCustomIndexState() {
      return initialState;
    },
  },
});

export const {
  setTabValue,
  setCreateCustomIndex,
  setIndexName,
  setSecurityGroupIds,
  setSavedSearchId,
  setFields,
  setNotificationEmails,
  setIsReadyOnlyView,
  resetCustomIndexState,
  setIndexStatus,
} = createCustomIndexSlice.actions;

export default createCustomIndexSlice.reducer;
